export default __webpack_public_path__ + "static/media/egoeast.f5225573.jpg";